<footer class="footer design-factory-v2">
    <div class="container">
    <span>&copy; Amadeus Copyright 2017-{{currentYear}}</span>
    </div>
</footer>

